/*
*numberof   滚动时的次数
*time       滚动数字的时间间隔
*pending    滚动时触发的函数
*success    滚动完毕触发
*/

var numberRoll = {
    install: function(Vue){
        Vue.prototype.$numberRoll = function(data){
            if(data.numbers === ''){//对numbers判空操作
                console.error('numbers error:numbers空');
                return false;
            }
            //定时器,滚动数字,滚动后数字,是否负数
            var interval = null;
            var num = 0;
            var time = null;
            var decimal = false;
            if(!data.numberof){//是否含有滚动次数,没有默认给20
                data.numberof = 20;
            } else {
                if(data.numbers < data.numberof){
                    data.numberof = parseInt(data.numbers);
                } else {
                    data.numberof = data.numberof.toFixed(0);
                }
            }
            if(data.numbers < 0){
                data.numbers = data.numbers * -1;
                decimal = true;
            }
            time = parseInt(parseInt(data.numbers) / data.numberof);
            interval = setInterval(function(){
                num += time;
                if(data.pending){
                    if(typeof data.pending === 'function'){
                        decimal ? data.pending(-num) : data.pending(num)
                        if(num > data.numbers){
                            decimal ? data.pending(-data.numbers) : data.pending(data.numbers)
                        }
                    } else {
                        console.error('pending error:pending不是一个function');
                    }
                }
                if(num > data.numbers){
                    clearInterval(interval);
                    if(data.success){
                        if(typeof data.success === 'function'){
                            data.success();
                        } else {
                            console.error('success error:success不是一个function');
                        };
                    }
                };
            },data.time ? data.time : 50);
        };
    }
};

export default numberRoll;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@xc/numberroll/numberRoll.js
// module id = iUaN
// module chunks = 6